import { FC } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { GridColDef } from '@mui/x-data-grid';
import Can from 'src/components/Can';
import LinkButton from 'src/components/LinkButton';
import Table from 'src/components/Table';
import TableActions from 'src/components/Table/Actions';
import StatusIcon from 'src/components/Table/StatusIcon';
import { BASE_PERMISSIONS } from 'src/constants/permissions/base';
import useApiQueryPagination from 'src/hooks/useApiQueryPagination';
import api from 'src/services/api';
import UserFilterSchema from 'src/validators/User/filter.schema';

import { Container } from './styles';
import UserFilters from './UserFilters';

const List: FC = () => {
  const {
    handlePageChange,
    handlePageSizeChange,
    isLoading,
    data: response,
    refetch,
  } = useApiQueryPagination(api.admin.users.useUsersQuery);

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'name', headerName: 'Nome', flex: 2 },
    { field: 'login', headerName: 'Login', flex: 1 },
    {
      field: 'status',
      headerName: 'Status',
      headerAlign: 'center',
      align: 'center',
      renderCell(params) {
        return <StatusIcon status={params.row.status} />;
      },
    },
    {
      field: 'actions',
      headerName: '',
      align: 'right',
      renderCell({ id, row }) {
        return (
          <TableActions
            resourceName="Usuário"
            resourceId={id}
            resourceStatus={row.status}
            editLink={`/usuarios/${id}`}
            editPermissions={[BASE_PERMISSIONS.USERS.UPDATE]}
            destroyApiEndpoint={api.admin.users.destroyUser}
            destroyPermissions={[BASE_PERMISSIONS.USERS.DESTROY]}
            restoreApiEndpoint={api.admin.users.restoreUser}
            restorePermissions={[BASE_PERMISSIONS.USERS.RESTORE]}
            descriptionPrefix={`O usuário ${row.name}`}
            onFinish={refetch}
          />
        );
      },
    },
  ];

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h5">Usuários</Typography>

            <Can permissions={[BASE_PERMISSIONS.USERS.STORE]}>
              <LinkButton
                to="/usuarios/novo"
                startIcon={<AddIcon />}
                color="primary"
                variant="contained"
                size="small"
              >
                Novo
              </LinkButton>
            </Can>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Table
                autoHeight
                rows={response?.data.data || []}
                pageSize={response?.data.meta.per_page}
                rowCount={response?.data.meta.total}
                columns={columns}
                loading={isLoading}
                pagination
                paginationMode="server"
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                showFilters
                filterProps={{
                  yupSchema: UserFilterSchema,
                  children: <UserFilters />,
                }}
                canSearch
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default List;
